import React from 'react';
import { Dialog, Switch, Typography, Button, Box, Stack } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface AgentStatusModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isEnabled: boolean;
}

const AgentStatusModal: React.FC<AgentStatusModalProps> = ({
  open,
  onClose,
  onConfirm,
  isEnabled
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <WarningIcon className={isEnabled ? "text-red-500" : "text-green-500"} />
          <Typography variant="h6">{isEnabled ? "Disable" : "Enable"} Agent</Typography>
        </Box>
        
        <Typography variant="body1" sx={{ mb: 3 }}>
          Are you sure you want to {isEnabled ? "disable" : "enable"} this agent?
          {isEnabled ? " This will prevent the agent from being used in workflows." : " This will allow the agent to be used in workflows."}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <Switch checked={!isEnabled} />
          <Typography variant="body2">{isEnabled ? "Disabled" : "Enabled"}</Typography>
        </Box>
        
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end' }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={onConfirm}
            color={isEnabled ? "error" : "primary"}
          >
            {isEnabled ? "Yes, Disable" : "Yes, Enable"}
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default AgentStatusModal;